module.exports = __webpack_public_path__ + "img/chat.405cbb0c.svg";